<template>
<div>
    <el-dialog :title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="70%" :visible.sync="viewData.visible">
        <!-- 选择价格协议 -->
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="small">
            <el-tabs>
                <el-tab-pane :key="1" label="基础信息">
                    <div class="des_box">
                        <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                            <el-descriptions-item label="采购联系人：" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="purchaseContacterName" style="margin-bottom: 0;">
                                    {{ dataForm.purchaseContacterName }}&nbsp;&nbsp;<el-button size="small" @click="selectPurchase()">选择</el-button>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="项目名称" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="projectName" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="订单编码" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="orderCode" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.orderCode" placeholder="订单编码" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="配件单位" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="supportingPartner" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.supportingPartner" placeholder="配件单位" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="订单状态" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="orderStatus" style="margin-bottom: 0;">
                                    <!-- <el-input size="small" v-model="dataForm.orderStatus" placeholder="订单状态" clearable></el-input> -->
                                    <el-select v-model="dataForm.orderStatus" placeholder="请选择" clearable style="width: 200px;">
                                        <el-option v-for="item in ORDER_STATUS" :key="item.value" :label="item.label" :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="订单类型" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="orderType" style="margin-bottom: 0;">
                                    <el-select v-model="dataForm.orderType" placeholder="请选择" clearable style="width: 200px;">
                                        <el-option v-for="item in ORDER_TYPE" :key="item.value" :label="item.label" :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="订单名称" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="orderName" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.orderName" placeholder="订单名称" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="收件人" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="recieveContacterName" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.recieveContacterName" placeholder="收件人" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="收货地址" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="recieveAddress" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.recieveAddress" placeholder="收货地址" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="采购联系人电话" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="purchaseContacterTel" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.purchaseContacterTel" placeholder="采购联系人电话" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="电子邮箱地址" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="purchaseContacterMail" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.purchaseContacterMail" placeholder="电子邮箱地址" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="收件人电话" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="recieveContacterTel" style="margin-bottom: 0;">
                                    <el-input size="small" v-model="dataForm.recieveContacterTel" placeholder="收件人电话" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="订单要求" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="orderRequirement" style="margin-bottom: 0;">
                                    <el-input type="textarea" size="small" v-model="dataForm.orderRequirement" :rows="3" placeholder="订单要求" clearable></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="备注" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="remark" style="margin-bottom: 0;">
                                    <el-input type="textarea" v-model="dataForm.remark" :rows="3" placeholder="备注"></el-input>
                                </el-form-item>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-tab-pane>
                <el-tab-pane :key="2" label="订单零件清单">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateOrderPartHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                                新增订单零件
                            </el-button>
                            <el-table :data="orderPartList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="partCode" header-align="center" align="left" label="物料编码">
                                </el-table-column>
                                <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
                                </el-table-column>
                                <el-table-column prop="unit" header-align="center" align="left" label="单位">
                                    <template slot-scope="scope">
                                        <span>{{getUnitName(scope.row.unit)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="正式订单" header-align="center">
                                    <el-table-column prop="count" header-align="center" align="right" label="正式订货数量">
                                    </el-table-column>
                                    <el-table-column width="" prop="arriveDate" header-align="center" align="right" :formatter="dateFormat" label="到货时间">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="预测订单" header-align="center">
                                    <el-table-column prop="preCount" header-align="center" align="right" label="预测订货数量">
                                    </el-table-column>
                                    <el-table-column prop="preArriveDate" header-align="center" align="right" :formatter="dateFormat" label="预测到货时间">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column header-align="center" align="left" width="150" label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="addOrUpdateOrderPartHandle(scope.row.id)" icon="el-icon-edit">
                                            修改
                                        </el-button>
                                        <el-button type="text" size="small" @click="deleteHandlePart(scope.row.id)" icon="el-icon-delete" class="button-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- </el-form-item> -->
                        </el-col>
                    </el-row>
                    <!-- 分页 -->
                    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
                    </el-pagination>
                </el-tab-pane>
                <el-tab-pane :key="4" label="附件文件">
                    <!-- TODO:上传下载 产看 需求文档 -->
                    <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align: right">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button size="small" type="success" @click="dataFormSubmit()">
                    生成订单管理
                </el-button>
                <span v-for="(item,index) in dataForm.taskActions" :key="index" style="margin-left: 10px;margin-right: 10px">
                    <el-button v-if="item.taskName == '提交审批单'" size="small" type="primary" @click="goToApprove()">
                        提交审批
                    </el-button>
                    <span v-if="item.flowRuleType && item.flowRuleType === 'action'">
                        <el-button type="success" size="small" @click="execApprove(dataForm.id, item.taskId, item.flowRuleType, item.normalValue,true)">通过
                        </el-button>
                        <el-button type="danger" size="small" @click="unQuote(dataForm.id, item.taskId, item.flowRuleType, item.reverseValue)">驳回
                        </el-button>
                    </span>
                </span>
                <el-button size="small" type="warning">
                    生成询价单
                </el-button>
                <el-button size="small" type="primary">
                    确定生成ASN
                </el-button>
            </el-col>
        </el-row>
        <common-user-dialog ref="commonUserDialog"></common-user-dialog>
        <!-- 弹窗, 新增 / 修改 零件-->
        <add-or-update-order-part v-if="addOrUpdateOrderPartVisible" ref="addOrUpdateOrderPart" @refreshOrderPartDataList="getOrderTblPartList"></add-or-update-order-part>
    </el-dialog>

    <el-dialog :title="'提示'" width="30%" :close-on-click-modal="false" :visible.sync="unQuoteReasonFlag">
        <el-row>
            <el-form label-width="0px" :rules="dataRule2" :model="dataForm" ref="dataForm">
                <el-form-item prop="unQuoteReason">
                    <el-input type="textarea" :rows="10" placeholder="请输入驳回原因" maxlength="200" v-model="dataForm.unQuoteReason">
                    </el-input>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row type="flex" justify="end">
            <el-button size="small" @click="unQuoteReasonFlag = false">取 消</el-button>
            <el-button size="small" type="primary" @click="UpdateBybohui()">确 定</el-button>
        </el-row>
    </el-dialog>

</div>
</template>

<script>
import AddOrUpdateOrderPart from "./order-appart-add-or-update";
import {
    getOrderById,
    createOrder,
    editOrder,
    getOrderTblPartList,
    deletePart,
    approve,
} from "@/controller/order";
import {
    ORDER_TYPE,
    ORDER_STATUS,
    USER_TYPE,
    DIALOG_CLOSED_TYPE,
} from '@/utils/const'
import {
    getUnitList
} from '@/controller/systemData'
import CommonUserDialog from "@/views/common/common-user-dialog";
import FilesUpDown from "@/views/common/file-up-down";
import moment from "moment";
export default {
    data() {
        return {
            FILE_BIZ_TYPE: 9,
            viewData: {
                visible: false,
                width: "",
            },
            ORDER_TYPE: ORDER_TYPE,
            ORDER_STATUS: ORDER_STATUS,
            orderPartList: [],
            unitList: [],
            addOrUpdateOrderPartVisible: false,
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataForm: {
                id: 0,
                projectName: '',
                orderCode: '',
                supportingPartner: '',
                orderStatus: '',
                orderType: '',
                orderName: '',
                recieveContacterName: '',
                recieveAddress: '',
                purchaseContacterName: '',
                purchaseContacterTel: '',
                purchaseContacterMail: '',
                recieveContacterTel: '',
                orderRequirement: '',
                remark: '',
                unQuoteReason: ''
            },
            dataRule: {
                name: [{
                    required: true,
                    message: "组织名称不能为空",
                    trigger: "blur",
                }, ],
                code: [{
                    required: true,
                    message: "组织代码不能为空",
                    trigger: "blur",
                }, ],
                tenantName: [{
                    required: true,
                    message: "请先在页面顶部导航栏选择租户",
                    trigger: "blur",
                }, ],
            },
            dataRule2: {
                unQuoteReason: [{
                    required: true,
                    message: '驳回原因不能为空',
                    trigger: 'blur'
                }]
            },
            unQuoteReasonFlag: false,
        };
    },
    components: {
        CommonUserDialog,
        AddOrUpdateOrderPart,
        FilesUpDown // 上传附件
    },
    mounted() {},
    methods: {
        // 新增 / 修改 零件表
        addOrUpdateOrderPartHandle(id) {
            this.addOrUpdateOrderPartVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateOrderPart.init(
                    id,
                    this.dataForm.id
                );
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getOrderTblPartList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getOrderTblPartList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 删除零件
        deleteHandlePart(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deletePart(ids)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getOrderTblPartList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        init(id) {
            this.dataForm.id = id || 0;
            this.orderPartList = [];
            this.viewData.visible = true;
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FilesUpDown.init(id, this.FILE_BIZ_TYPE, null);
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id找订单对象
                    getOrderById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00" && data.body) {
                            // this.dataForm.projectName = data.body.projectName;
                            // this.dataForm.orderCode = data.body.orderCode;
                            // this.dataForm.supportingPartner = data.body.supportingPartner;
                            // this.dataForm.orderStatus = data.body.orderStatus;
                            // this.dataForm.orderType = data.body.orderType;
                            // this.dataForm.orderName = data.body.orderName;
                            // this.dataForm.recieveContacterName = data.body.recieveContacterName;
                            // this.dataForm.recieveAddress = data.body.recieveAddress;
                            // this.dataForm.purchaseContacterName = data.body.purchaseContacterName;
                            // this.dataForm.purchaseContacterTel = data.body.purchaseContacterTel;
                            // this.dataForm.purchaseContacterMail = data.body.purchaseContacterMail;
                            // this.dataForm.recieveContacterTel = data.body.recieveContacterTel;
                            // this.dataForm.orderRequirement = data.body.orderRequirement;
                            // this.dataForm.remark = data.body.remark;
                            this.dataForm = data.body;

                        }
                    });
                    this.getOrderTblPartList();
                }
            });
            this.getUnitList()
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        // 查所有订单零件表
        getOrderTblPartList() {
            getOrderTblPartList({
                orderId: this.dataForm.id,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.orderPartList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.orderPartList = [];
                    this.totalPage = 0;
                }
            });
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD前");
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let orderParams = {
                        id: this.dataForm.id || undefined,
                        'projectName': this.dataForm.projectName,
                        'orderCode': this.dataForm.orderCode,
                        'supportingPartner': this.dataForm.supportingPartner,
                        'orderStatus': this.dataForm.orderStatus,
                        'orderType': this.dataForm.orderType,
                        'orderName': this.dataForm.orderName,
                        'recieveContacterName': this.dataForm.recieveContacterName,
                        'recieveAddress': this.dataForm.recieveAddress,
                        'purchaseContacterName': this.dataForm.purchaseContacterName,
                        'purchaseContacterTel': this.dataForm.purchaseContacterTel,
                        'purchaseContacterMail': this.dataForm.purchaseContacterMail,
                        'recieveContacterTel': this.dataForm.recieveContacterTel,
                        'orderRequirement': this.dataForm.orderRequirement,
                        'remark': this.dataForm.remark,
                        'source': 'SRM',
                    };
                    if (this.dataForm.id) {
                        editOrder(orderParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "订单修改成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            // this.viewData.visible = false;
                                            this.$emit("refreshDataList");
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createOrder(orderParams).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm.id = data.body.id;
                                this.$message({
                                    message: "订单创建成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        selectPurchase() {
            // this.$nextTick(() => {
            //     this.dataForm.projectManagerName = 'test'
            // })
            //const _this = this
            this.$refs.commonUserDialog.open(USER_TYPE.PERCHASE)
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // this.dataForm.projectManagerId = payload.data.id
                    this.dataForm.purchaseContacterName = payload.data.realName
                }
            };
        },
        goToApprove() {
            let actions = this.dataForm.taskActions;
            if (actions && actions.length > 0) {
                let action = actions[0];
                this.dataForm.flowTaskId = action.taskId,
                    this.dataForm.paramKey = action.flowType,
                    this.dataForm.paramVal = action.val,
                    approve(this.dataForm).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                onClose: () => {
                                    this.viewData.visible = false
                                    console.log('refreshDataList')
                                    this.$emit('refreshDataList')
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
            } else {
                this.$message.error("当前工作流未启动！不可提交审批")
                return
            }

        },
        execApprove(id, taskId, flowType, val, isPass) {
            let text = "通过";
            if (!isPass) {
                text = "驳回";
            }
            this.$confirm(`确定进行${text}操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                approve({
                    'id': id,
                    'flowTaskId': taskId,
                    'paramKey': flowType,
                    'paramVal': val,
                    "unQuoteReason": this.dataForm.unQuoteReason,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            onClose: () => {
                                this.viewData.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
                this.viewData.visible = false;
            });
        },
        //驳回原因
        unQuote(taskId, flowRuleType, reverseValue) {
            this.dataForm.taskId = taskId
            this.dataForm.flowType = flowRuleType
            this.dataForm.paramVal = reverseValue
            this.dataForm.unQuoteReason = ""
            this.unQuoteReasonFlag = true
            // execApprove(id, taskId, flowType, val,false)
        },
        // 确定驳回
        UpdateBybohui() {
            this.unQuoteReasonFlag = false;
            this.execApprove(this.dataForm.id, this.dataForm.taskId, this.dataForm.flowType, this.dataForm.paramVal, false)
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 435.5px;'
        },
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #f56c6c;
}

.mb15 {
    margin-bottom: 15px;
}

.fr {
    float: right;
}
</style>
